export default {
  'financial.dre.form.planAccount': 'Plano de Conta',
};
